import { supabase } from './supabase';

/**
 * Auth Manager for Supabase
 * Handles auth state changes in a non-blocking way to prevent deadlocks
 * Based on GitHub issues: https://github.com/nuxt-modules/supabase/issues/273
 * and https://github.com/orgs/supabase/discussions/35069
 */
class AuthManager {
  constructor() {
    this.subscription = null;
    this.listeners = new Set();
    this.init();
  }

  init() {
    // Set up auth state change listener with non-blocking approach
    // This prevents deadlocks when switching tabs
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (event, session) => {
        // Use setTimeout to make this non-blocking (prevents deadlocks)
        setTimeout(() => {
          this.handleAuthStateChange(event, session);
        }, 0);
      }
    );

    this.subscription = subscription;
  }

  handleAuthStateChange(event, session) {
    console.log('[AUTH] Auth state changed:', { event, hasSession: !!session });
    
    // Notify all listeners
    this.listeners.forEach(callback => {
      try {
        callback(event, session);
      } catch (error) {
        console.error('[AUTH] Listener error:', error);
      }
    });
  }

  addListener(callback) {
    this.listeners.add(callback);
    return () => this.listeners.delete(callback);
  }

  destroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.listeners.clear();
  }
}

// Create singleton instance
const authManager = new AuthManager();

export default authManager;
